var map = {
	"./AIChip3Icon": [
		"./src/components/ui/svgIcon/AIChip3Icon.js",
		9,
		"src_components_ui_svgIcon_AIChip3Icon_js"
	],
	"./AIChip3Icon.js": [
		"./src/components/ui/svgIcon/AIChip3Icon.js",
		9,
		"src_components_ui_svgIcon_AIChip3Icon_js"
	],
	"./AdaCardanoIcon": [
		"./src/components/ui/svgIcon/AdaCardanoIcon.jsx",
		9,
		"src_components_ui_svgIcon_AdaCardanoIcon_jsx"
	],
	"./AdaCardanoIcon.jsx": [
		"./src/components/ui/svgIcon/AdaCardanoIcon.jsx",
		9,
		"src_components_ui_svgIcon_AdaCardanoIcon_jsx"
	],
	"./AddDocumentsIcon": [
		"./src/components/ui/svgIcon/AddDocumentsIcon.js",
		9,
		"src_components_ui_svgIcon_AddDocumentsIcon_js"
	],
	"./AddDocumentsIcon.js": [
		"./src/components/ui/svgIcon/AddDocumentsIcon.js",
		9,
		"src_components_ui_svgIcon_AddDocumentsIcon_js"
	],
	"./AddFile": [
		"./src/components/ui/svgIcon/AddFile.js",
		9
	],
	"./AddFile.js": [
		"./src/components/ui/svgIcon/AddFile.js",
		9
	],
	"./AddUserIcon": [
		"./src/components/ui/svgIcon/AddUserIcon.js",
		9,
		"src_components_ui_svgIcon_AddUserIcon_js"
	],
	"./AddUserIcon.js": [
		"./src/components/ui/svgIcon/AddUserIcon.js",
		9,
		"src_components_ui_svgIcon_AddUserIcon_js"
	],
	"./AparatIcon": [
		"./src/components/ui/svgIcon/AparatIcon.js",
		9,
		"src_components_ui_svgIcon_AparatIcon_js"
	],
	"./AparatIcon.js": [
		"./src/components/ui/svgIcon/AparatIcon.js",
		9,
		"src_components_ui_svgIcon_AparatIcon_js"
	],
	"./ArrowCircleIcon": [
		"./src/components/ui/svgIcon/ArrowCircleIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowCircleIcon_js"
	],
	"./ArrowCircleIcon.js": [
		"./src/components/ui/svgIcon/ArrowCircleIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowCircleIcon_js"
	],
	"./ArrowDownHeadIcon": [
		"./src/components/ui/svgIcon/ArrowDownHeadIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowDownHeadIcon_js"
	],
	"./ArrowDownHeadIcon.js": [
		"./src/components/ui/svgIcon/ArrowDownHeadIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowDownHeadIcon_js"
	],
	"./ArrowDownIcon": [
		"./src/components/ui/svgIcon/ArrowDownIcon.js",
		9
	],
	"./ArrowDownIcon.js": [
		"./src/components/ui/svgIcon/ArrowDownIcon.js",
		9
	],
	"./ArrowDownSquareIcon": [
		"./src/components/ui/svgIcon/ArrowDownSquareIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowDownSquareIcon_js"
	],
	"./ArrowDownSquareIcon.js": [
		"./src/components/ui/svgIcon/ArrowDownSquareIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowDownSquareIcon_js"
	],
	"./ArrowLeftCheckboxIcon": [
		"./src/components/ui/svgIcon/ArrowLeftCheckboxIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowLeftCheckboxIcon_js"
	],
	"./ArrowLeftCheckboxIcon.js": [
		"./src/components/ui/svgIcon/ArrowLeftCheckboxIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowLeftCheckboxIcon_js"
	],
	"./ArrowLeftCircleIcon": [
		"./src/components/ui/svgIcon/ArrowLeftCircleIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowLeftCircleIcon_js"
	],
	"./ArrowLeftCircleIcon.js": [
		"./src/components/ui/svgIcon/ArrowLeftCircleIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowLeftCircleIcon_js"
	],
	"./ArrowLeftHeadIcon": [
		"./src/components/ui/svgIcon/ArrowLeftHeadIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowLeftHeadIcon_js"
	],
	"./ArrowLeftHeadIcon.js": [
		"./src/components/ui/svgIcon/ArrowLeftHeadIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowLeftHeadIcon_js"
	],
	"./ArrowLeftIcon": [
		"./src/components/ui/svgIcon/ArrowLeftIcon.js",
		9
	],
	"./ArrowLeftIcon.js": [
		"./src/components/ui/svgIcon/ArrowLeftIcon.js",
		9
	],
	"./ArrowLeftSquareIcon": [
		"./src/components/ui/svgIcon/ArrowLeftSquareIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowLeftSquareIcon_js"
	],
	"./ArrowLeftSquareIcon.js": [
		"./src/components/ui/svgIcon/ArrowLeftSquareIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowLeftSquareIcon_js"
	],
	"./ArrowLeftSquareOutlineIcon": [
		"./src/components/ui/svgIcon/ArrowLeftSquareOutlineIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowLeftSquareOutlineIcon_js"
	],
	"./ArrowLeftSquareOutlineIcon.js": [
		"./src/components/ui/svgIcon/ArrowLeftSquareOutlineIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowLeftSquareOutlineIcon_js"
	],
	"./ArrowRightIcon": [
		"./src/components/ui/svgIcon/ArrowRightIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowRightIcon_js"
	],
	"./ArrowRightIcon.js": [
		"./src/components/ui/svgIcon/ArrowRightIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowRightIcon_js"
	],
	"./ArrowRightSquareIcon": [
		"./src/components/ui/svgIcon/ArrowRightSquareIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowRightSquareIcon_js"
	],
	"./ArrowRightSquareIcon.js": [
		"./src/components/ui/svgIcon/ArrowRightSquareIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowRightSquareIcon_js"
	],
	"./ArrowUpIcon": [
		"./src/components/ui/svgIcon/ArrowUpIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowUpIcon_js-_3ddc2"
	],
	"./ArrowUpIcon.js": [
		"./src/components/ui/svgIcon/ArrowUpIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowUpIcon_js-_3ddc2"
	],
	"./ArrowUpSquareIcon": [
		"./src/components/ui/svgIcon/ArrowUpSquareIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowUpSquareIcon_js"
	],
	"./ArrowUpSquareIcon.js": [
		"./src/components/ui/svgIcon/ArrowUpSquareIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowUpSquareIcon_js"
	],
	"./ArrowsBigArrowsDownLeftIcon": [
		"./src/components/ui/svgIcon/ArrowsBigArrowsDownLeftIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowsBigArrowsDownLeftIcon_js"
	],
	"./ArrowsBigArrowsDownLeftIcon.js": [
		"./src/components/ui/svgIcon/ArrowsBigArrowsDownLeftIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowsBigArrowsDownLeftIcon_js"
	],
	"./ArrowsBigArrowsRightUpIcon": [
		"./src/components/ui/svgIcon/ArrowsBigArrowsRightUpIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowsBigArrowsRightUpIcon_js"
	],
	"./ArrowsBigArrowsRightUpIcon.js": [
		"./src/components/ui/svgIcon/ArrowsBigArrowsRightUpIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowsBigArrowsRightUpIcon_js"
	],
	"./ArrowsRightSquareIcon": [
		"./src/components/ui/svgIcon/ArrowsRightSquareIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowsRightSquareIcon_js"
	],
	"./ArrowsRightSquareIcon.js": [
		"./src/components/ui/svgIcon/ArrowsRightSquareIcon.js",
		9,
		"src_components_ui_svgIcon_ArrowsRightSquareIcon_js"
	],
	"./AttachIcon": [
		"./src/components/ui/svgIcon/AttachIcon.js",
		9,
		"src_components_ui_svgIcon_AttachIcon_js"
	],
	"./AttachIcon.js": [
		"./src/components/ui/svgIcon/AttachIcon.js",
		9,
		"src_components_ui_svgIcon_AttachIcon_js"
	],
	"./BarcodeScanIcon": [
		"./src/components/ui/svgIcon/BarcodeScanIcon.js",
		9,
		"src_components_ui_svgIcon_BarcodeScanIcon_js"
	],
	"./BarcodeScanIcon.js": [
		"./src/components/ui/svgIcon/BarcodeScanIcon.js",
		9,
		"src_components_ui_svgIcon_BarcodeScanIcon_js"
	],
	"./BoardMenuIcon": [
		"./src/components/ui/svgIcon/BoardMenuIcon.js",
		9,
		"src_components_ui_svgIcon_BoardMenuIcon_js"
	],
	"./BoardMenuIcon.js": [
		"./src/components/ui/svgIcon/BoardMenuIcon.js",
		9,
		"src_components_ui_svgIcon_BoardMenuIcon_js"
	],
	"./BoardTasksIcon": [
		"./src/components/ui/svgIcon/BoardTasksIcon.js",
		9,
		"src_components_ui_svgIcon_BoardTasksIcon_js"
	],
	"./BoardTasksIcon.js": [
		"./src/components/ui/svgIcon/BoardTasksIcon.js",
		9,
		"src_components_ui_svgIcon_BoardTasksIcon_js"
	],
	"./BoatOnWaterIcon": [
		"./src/components/ui/svgIcon/BoatOnWaterIcon.js",
		9,
		"src_components_ui_svgIcon_BoatOnWaterIcon_js"
	],
	"./BoatOnWaterIcon.js": [
		"./src/components/ui/svgIcon/BoatOnWaterIcon.js",
		9,
		"src_components_ui_svgIcon_BoatOnWaterIcon_js"
	],
	"./BookFillIcon": [
		"./src/components/ui/svgIcon/BookFillIcon.js",
		9,
		"src_components_ui_svgIcon_BookFillIcon_js"
	],
	"./BookFillIcon.js": [
		"./src/components/ui/svgIcon/BookFillIcon.js",
		9,
		"src_components_ui_svgIcon_BookFillIcon_js"
	],
	"./BookIcon": [
		"./src/components/ui/svgIcon/BookIcon.js",
		9,
		"src_components_ui_svgIcon_BookIcon_js"
	],
	"./BookIcon.js": [
		"./src/components/ui/svgIcon/BookIcon.js",
		9,
		"src_components_ui_svgIcon_BookIcon_js"
	],
	"./BookmarkIcon": [
		"./src/components/ui/svgIcon/BookmarkIcon.js",
		9,
		"src_components_ui_svgIcon_BookmarkIcon_js"
	],
	"./BookmarkIcon.js": [
		"./src/components/ui/svgIcon/BookmarkIcon.js",
		9,
		"src_components_ui_svgIcon_BookmarkIcon_js"
	],
	"./BuildingFillIcon": [
		"./src/components/ui/svgIcon/BuildingFillIcon.js",
		9,
		"src_components_ui_svgIcon_BuildingFillIcon_js"
	],
	"./BuildingFillIcon.js": [
		"./src/components/ui/svgIcon/BuildingFillIcon.js",
		9,
		"src_components_ui_svgIcon_BuildingFillIcon_js"
	],
	"./BuildingOfficeIcon": [
		"./src/components/ui/svgIcon/BuildingOfficeIcon.js",
		9,
		"src_components_ui_svgIcon_BuildingOfficeIcon_js"
	],
	"./BuildingOfficeIcon.js": [
		"./src/components/ui/svgIcon/BuildingOfficeIcon.js",
		9,
		"src_components_ui_svgIcon_BuildingOfficeIcon_js"
	],
	"./BuildingOfficesIcon": [
		"./src/components/ui/svgIcon/BuildingOfficesIcon.js",
		9,
		"src_components_ui_svgIcon_BuildingOfficesIcon_js"
	],
	"./BuildingOfficesIcon.js": [
		"./src/components/ui/svgIcon/BuildingOfficesIcon.js",
		9,
		"src_components_ui_svgIcon_BuildingOfficesIcon_js"
	],
	"./BuubleChartIcon": [
		"./src/components/ui/svgIcon/BuubleChartIcon.js",
		9,
		"src_components_ui_svgIcon_BuubleChartIcon_js"
	],
	"./BuubleChartIcon.js": [
		"./src/components/ui/svgIcon/BuubleChartIcon.js",
		9,
		"src_components_ui_svgIcon_BuubleChartIcon_js"
	],
	"./CalculateIcon": [
		"./src/components/ui/svgIcon/CalculateIcon.js",
		9,
		"src_components_ui_svgIcon_CalculateIcon_js"
	],
	"./CalculateIcon.js": [
		"./src/components/ui/svgIcon/CalculateIcon.js",
		9,
		"src_components_ui_svgIcon_CalculateIcon_js"
	],
	"./CalendarDayFillIcon": [
		"./src/components/ui/svgIcon/CalendarDayFillIcon.js",
		9
	],
	"./CalendarDayFillIcon.js": [
		"./src/components/ui/svgIcon/CalendarDayFillIcon.js",
		9
	],
	"./CalendarIcon": [
		"./src/components/ui/svgIcon/CalendarIcon.js",
		9,
		"src_components_ui_svgIcon_CalendarIcon_js-_17ee5"
	],
	"./CalendarIcon.js": [
		"./src/components/ui/svgIcon/CalendarIcon.js",
		9,
		"src_components_ui_svgIcon_CalendarIcon_js-_17ee5"
	],
	"./Calender2Line": [
		"./src/components/ui/svgIcon/Calender2Line.js",
		9,
		"src_components_ui_svgIcon_Calender2Line_js"
	],
	"./Calender2Line.js": [
		"./src/components/ui/svgIcon/Calender2Line.js",
		9,
		"src_components_ui_svgIcon_Calender2Line_js"
	],
	"./CalenderCheckIcon": [
		"./src/components/ui/svgIcon/CalenderCheckIcon.js",
		9,
		"src_components_ui_svgIcon_CalenderCheckIcon_js"
	],
	"./CalenderCheckIcon.js": [
		"./src/components/ui/svgIcon/CalenderCheckIcon.js",
		9,
		"src_components_ui_svgIcon_CalenderCheckIcon_js"
	],
	"./CarIcon": [
		"./src/components/ui/svgIcon/CarIcon.js",
		9,
		"src_components_ui_svgIcon_CarIcon_js"
	],
	"./CarIcon.js": [
		"./src/components/ui/svgIcon/CarIcon.js",
		9,
		"src_components_ui_svgIcon_CarIcon_js"
	],
	"./CategoryIcon": [
		"./src/components/ui/svgIcon/CategoryIcon.js",
		9,
		"src_components_ui_svgIcon_CategoryIcon_js"
	],
	"./CategoryIcon.js": [
		"./src/components/ui/svgIcon/CategoryIcon.js",
		9,
		"src_components_ui_svgIcon_CategoryIcon_js"
	],
	"./ChainLinkIcon": [
		"./src/components/ui/svgIcon/ChainLinkIcon.js",
		9,
		"src_components_ui_svgIcon_ChainLinkIcon_js"
	],
	"./ChainLinkIcon.js": [
		"./src/components/ui/svgIcon/ChainLinkIcon.js",
		9,
		"src_components_ui_svgIcon_ChainLinkIcon_js"
	],
	"./ChangeFile": [
		"./src/components/ui/svgIcon/ChangeFile.js",
		9
	],
	"./ChangeFile.js": [
		"./src/components/ui/svgIcon/ChangeFile.js",
		9
	],
	"./ChangePassIcon": [
		"./src/components/ui/svgIcon/ChangePassIcon.js",
		9,
		"src_components_ui_svgIcon_ChangePassIcon_js"
	],
	"./ChangePassIcon.js": [
		"./src/components/ui/svgIcon/ChangePassIcon.js",
		9,
		"src_components_ui_svgIcon_ChangePassIcon_js"
	],
	"./ChangingIcon": [
		"./src/components/ui/svgIcon/ChangingIcon.js",
		9,
		"src_components_ui_svgIcon_ChangingIcon_js"
	],
	"./ChangingIcon.js": [
		"./src/components/ui/svgIcon/ChangingIcon.js",
		9,
		"src_components_ui_svgIcon_ChangingIcon_js"
	],
	"./ChartThreeBarIcon": [
		"./src/components/ui/svgIcon/ChartThreeBarIcon.js",
		9,
		"src_components_ui_svgIcon_ChartThreeBarIcon_js"
	],
	"./ChartThreeBarIcon.js": [
		"./src/components/ui/svgIcon/ChartThreeBarIcon.js",
		9,
		"src_components_ui_svgIcon_ChartThreeBarIcon_js"
	],
	"./ChatIcon": [
		"./src/components/ui/svgIcon/ChatIcon.js",
		9,
		"src_components_ui_svgIcon_ChatIcon_js"
	],
	"./ChatIcon.js": [
		"./src/components/ui/svgIcon/ChatIcon.js",
		9,
		"src_components_ui_svgIcon_ChatIcon_js"
	],
	"./CheckBadge": [
		"./src/components/ui/svgIcon/CheckBadge.js",
		9,
		"src_components_ui_svgIcon_CheckBadge_js-_2e375"
	],
	"./CheckBadge.js": [
		"./src/components/ui/svgIcon/CheckBadge.js",
		9,
		"src_components_ui_svgIcon_CheckBadge_js-_2e375"
	],
	"./CheckBadgeEmptyIcon": [
		"./src/components/ui/svgIcon/CheckBadgeEmptyIcon.js",
		9,
		"src_components_ui_svgIcon_CheckBadgeEmptyIcon_js"
	],
	"./CheckBadgeEmptyIcon.js": [
		"./src/components/ui/svgIcon/CheckBadgeEmptyIcon.js",
		9,
		"src_components_ui_svgIcon_CheckBadgeEmptyIcon_js"
	],
	"./CheckCircleIcon": [
		"./src/components/ui/svgIcon/CheckCircleIcon.js",
		9,
		"src_components_ui_svgIcon_CheckCircleIcon_js"
	],
	"./CheckCircleIcon.js": [
		"./src/components/ui/svgIcon/CheckCircleIcon.js",
		9,
		"src_components_ui_svgIcon_CheckCircleIcon_js"
	],
	"./CheckSqaureIcon": [
		"./src/components/ui/svgIcon/CheckSqaureIcon.js",
		9,
		"src_components_ui_svgIcon_CheckSqaureIcon_js"
	],
	"./CheckSqaureIcon.js": [
		"./src/components/ui/svgIcon/CheckSqaureIcon.js",
		9,
		"src_components_ui_svgIcon_CheckSqaureIcon_js"
	],
	"./CheckSquareIcon": [
		"./src/components/ui/svgIcon/CheckSquareIcon.js",
		9,
		"src_components_ui_svgIcon_CheckSquareIcon_js"
	],
	"./CheckSquareIcon.js": [
		"./src/components/ui/svgIcon/CheckSquareIcon.js",
		9,
		"src_components_ui_svgIcon_CheckSquareIcon_js"
	],
	"./CheckmarkIcon": [
		"./src/components/ui/svgIcon/CheckmarkIcon.js",
		9,
		"src_components_ui_svgIcon_CheckmarkIcon_js"
	],
	"./CheckmarkIcon.js": [
		"./src/components/ui/svgIcon/CheckmarkIcon.js",
		9,
		"src_components_ui_svgIcon_CheckmarkIcon_js"
	],
	"./ChemistryFlaskIcon": [
		"./src/components/ui/svgIcon/ChemistryFlaskIcon.js",
		9,
		"src_components_ui_svgIcon_ChemistryFlaskIcon_js"
	],
	"./ChemistryFlaskIcon.js": [
		"./src/components/ui/svgIcon/ChemistryFlaskIcon.js",
		9,
		"src_components_ui_svgIcon_ChemistryFlaskIcon_js"
	],
	"./ChevronLeftIcon": [
		"./src/components/ui/svgIcon/ChevronLeftIcon.js",
		9,
		"src_components_ui_svgIcon_ChevronLeftIcon_js"
	],
	"./ChevronLeftIcon.js": [
		"./src/components/ui/svgIcon/ChevronLeftIcon.js",
		9,
		"src_components_ui_svgIcon_ChevronLeftIcon_js"
	],
	"./CircleClockEmptyIcon": [
		"./src/components/ui/svgIcon/CircleClockEmptyIcon.js",
		9,
		"src_components_ui_svgIcon_CircleClockEmptyIcon_js"
	],
	"./CircleClockEmptyIcon.js": [
		"./src/components/ui/svgIcon/CircleClockEmptyIcon.js",
		9,
		"src_components_ui_svgIcon_CircleClockEmptyIcon_js"
	],
	"./CircleClockFillIcon": [
		"./src/components/ui/svgIcon/CircleClockFillIcon.js",
		9
	],
	"./CircleClockFillIcon.js": [
		"./src/components/ui/svgIcon/CircleClockFillIcon.js",
		9
	],
	"./CircleClockIcon": [
		"./src/components/ui/svgIcon/CircleClockIcon.js",
		9,
		"src_components_ui_svgIcon_CircleClockIcon_js"
	],
	"./CircleClockIcon.js": [
		"./src/components/ui/svgIcon/CircleClockIcon.js",
		9,
		"src_components_ui_svgIcon_CircleClockIcon_js"
	],
	"./CircleGridInterfaceIcon": [
		"./src/components/ui/svgIcon/CircleGridInterfaceIcon.js",
		9,
		"src_components_ui_svgIcon_CircleGridInterfaceIcon_js"
	],
	"./CircleGridInterfaceIcon.js": [
		"./src/components/ui/svgIcon/CircleGridInterfaceIcon.js",
		9,
		"src_components_ui_svgIcon_CircleGridInterfaceIcon_js"
	],
	"./CircleStickerIcon": [
		"./src/components/ui/svgIcon/CircleStickerIcon.js",
		9,
		"src_components_ui_svgIcon_CircleStickerIcon_js"
	],
	"./CircleStickerIcon.js": [
		"./src/components/ui/svgIcon/CircleStickerIcon.js",
		9,
		"src_components_ui_svgIcon_CircleStickerIcon_js"
	],
	"./ClipboardCheckIcon": [
		"./src/components/ui/svgIcon/ClipboardCheckIcon.js",
		9,
		"src_components_ui_svgIcon_ClipboardCheckIcon_js"
	],
	"./ClipboardCheckIcon.js": [
		"./src/components/ui/svgIcon/ClipboardCheckIcon.js",
		9,
		"src_components_ui_svgIcon_ClipboardCheckIcon_js"
	],
	"./ClipboardCloseIcon": [
		"./src/components/ui/svgIcon/ClipboardCloseIcon.js",
		9,
		"src_components_ui_svgIcon_ClipboardCloseIcon_js"
	],
	"./ClipboardCloseIcon.js": [
		"./src/components/ui/svgIcon/ClipboardCloseIcon.js",
		9,
		"src_components_ui_svgIcon_ClipboardCloseIcon_js"
	],
	"./ClipboardTextIcon": [
		"./src/components/ui/svgIcon/ClipboardTextIcon.js",
		9,
		"src_components_ui_svgIcon_ClipboardTextIcon_js"
	],
	"./ClipboardTextIcon.js": [
		"./src/components/ui/svgIcon/ClipboardTextIcon.js",
		9,
		"src_components_ui_svgIcon_ClipboardTextIcon_js"
	],
	"./ClockDashIcon": [
		"./src/components/ui/svgIcon/ClockDashIcon.js",
		9,
		"src_components_ui_svgIcon_ClockDashIcon_js"
	],
	"./ClockDashIcon.js": [
		"./src/components/ui/svgIcon/ClockDashIcon.js",
		9,
		"src_components_ui_svgIcon_ClockDashIcon_js"
	],
	"./CloseIcon": [
		"./src/components/ui/svgIcon/CloseIcon.js",
		9
	],
	"./CloseIcon.js": [
		"./src/components/ui/svgIcon/CloseIcon.js",
		9
	],
	"./CloseSqreIcon": [
		"./src/components/ui/svgIcon/CloseSqreIcon.js",
		9,
		"src_components_ui_svgIcon_CloseSqreIcon_js"
	],
	"./CloseSqreIcon.js": [
		"./src/components/ui/svgIcon/CloseSqreIcon.js",
		9,
		"src_components_ui_svgIcon_CloseSqreIcon_js"
	],
	"./CloseSquareIcon": [
		"./src/components/ui/svgIcon/CloseSquareIcon.js",
		9,
		"src_components_ui_svgIcon_CloseSquareIcon_js"
	],
	"./CloseSquareIcon.js": [
		"./src/components/ui/svgIcon/CloseSquareIcon.js",
		9,
		"src_components_ui_svgIcon_CloseSquareIcon_js"
	],
	"./CloudRainIcon": [
		"./src/components/ui/svgIcon/CloudRainIcon.js",
		9,
		"src_components_ui_svgIcon_CloudRainIcon_js"
	],
	"./CloudRainIcon.js": [
		"./src/components/ui/svgIcon/CloudRainIcon.js",
		9,
		"src_components_ui_svgIcon_CloudRainIcon_js"
	],
	"./CloudUploadIcon": [
		"./src/components/ui/svgIcon/CloudUploadIcon.js",
		9,
		"src_components_ui_svgIcon_CloudUploadIcon_js"
	],
	"./CloudUploadIcon.js": [
		"./src/components/ui/svgIcon/CloudUploadIcon.js",
		9,
		"src_components_ui_svgIcon_CloudUploadIcon_js"
	],
	"./CodeSandBoxIcon": [
		"./src/components/ui/svgIcon/CodeSandBoxIcon.js",
		9,
		"src_components_ui_svgIcon_CodeSandBoxIcon_js"
	],
	"./CodeSandBoxIcon.js": [
		"./src/components/ui/svgIcon/CodeSandBoxIcon.js",
		9,
		"src_components_ui_svgIcon_CodeSandBoxIcon_js"
	],
	"./ConnectionIcon": [
		"./src/components/ui/svgIcon/ConnectionIcon.js",
		9,
		"src_components_ui_svgIcon_ConnectionIcon_js"
	],
	"./ConnectionIcon.js": [
		"./src/components/ui/svgIcon/ConnectionIcon.js",
		9,
		"src_components_ui_svgIcon_ConnectionIcon_js"
	],
	"./CupIcon": [
		"./src/components/ui/svgIcon/CupIcon.js",
		9,
		"src_components_ui_svgIcon_CupIcon_js"
	],
	"./CupIcon.js": [
		"./src/components/ui/svgIcon/CupIcon.js",
		9,
		"src_components_ui_svgIcon_CupIcon_js"
	],
	"./CustomIcons": [
		"./src/components/ui/svgIcon/CustomIcons.js",
		9
	],
	"./CustomIcons.js": [
		"./src/components/ui/svgIcon/CustomIcons.js",
		9
	],
	"./Danger": [
		"./src/components/ui/svgIcon/Danger.js",
		9,
		"src_components_ui_svgIcon_Danger_js"
	],
	"./Danger.js": [
		"./src/components/ui/svgIcon/Danger.js",
		9,
		"src_components_ui_svgIcon_Danger_js"
	],
	"./DangerIcon": [
		"./src/components/ui/svgIcon/DangerIcon.js",
		9
	],
	"./DangerIcon.js": [
		"./src/components/ui/svgIcon/DangerIcon.js",
		9
	],
	"./DangerLineIcon": [
		"./src/components/ui/svgIcon/DangerLineIcon.js",
		9,
		"src_components_ui_svgIcon_DangerLineIcon_js"
	],
	"./DangerLineIcon.js": [
		"./src/components/ui/svgIcon/DangerLineIcon.js",
		9,
		"src_components_ui_svgIcon_DangerLineIcon_js"
	],
	"./DataSetIcon": [
		"./src/components/ui/svgIcon/DataSetIcon.js",
		9,
		"src_components_ui_svgIcon_DataSetIcon_js"
	],
	"./DataSetIcon.js": [
		"./src/components/ui/svgIcon/DataSetIcon.js",
		9,
		"src_components_ui_svgIcon_DataSetIcon_js"
	],
	"./DcoumentCheck": [
		"./src/components/ui/svgIcon/DcoumentCheck.js",
		9,
		"src_components_ui_svgIcon_DcoumentCheck_js"
	],
	"./DcoumentCheck.js": [
		"./src/components/ui/svgIcon/DcoumentCheck.js",
		9,
		"src_components_ui_svgIcon_DcoumentCheck_js"
	],
	"./Delete2LineIcon": [
		"./src/components/ui/svgIcon/Delete2LineIcon.js",
		9,
		"src_components_ui_svgIcon_Delete2LineIcon_js"
	],
	"./Delete2LineIcon.js": [
		"./src/components/ui/svgIcon/Delete2LineIcon.js",
		9,
		"src_components_ui_svgIcon_Delete2LineIcon_js"
	],
	"./DeleteEmptyTrashIcon": [
		"./src/components/ui/svgIcon/DeleteEmptyTrashIcon.js",
		9,
		"src_components_ui_svgIcon_DeleteEmptyTrashIcon_js"
	],
	"./DeleteEmptyTrashIcon.js": [
		"./src/components/ui/svgIcon/DeleteEmptyTrashIcon.js",
		9,
		"src_components_ui_svgIcon_DeleteEmptyTrashIcon_js"
	],
	"./DeleteFile": [
		"./src/components/ui/svgIcon/DeleteFile.js",
		9
	],
	"./DeleteFile.js": [
		"./src/components/ui/svgIcon/DeleteFile.js",
		9
	],
	"./DeleteIcon": [
		"./src/components/ui/svgIcon/DeleteIcon.js",
		9
	],
	"./DeleteIcon.js": [
		"./src/components/ui/svgIcon/DeleteIcon.js",
		9
	],
	"./DeliveryBox2Icon": [
		"./src/components/ui/svgIcon/DeliveryBox2Icon.js",
		9,
		"src_components_ui_svgIcon_DeliveryBox2Icon_js"
	],
	"./DeliveryBox2Icon.js": [
		"./src/components/ui/svgIcon/DeliveryBox2Icon.js",
		9,
		"src_components_ui_svgIcon_DeliveryBox2Icon_js"
	],
	"./DeliveryBoxIcon": [
		"./src/components/ui/svgIcon/DeliveryBoxIcon.js",
		9,
		"src_components_ui_svgIcon_DeliveryBoxIcon_js"
	],
	"./DeliveryBoxIcon copy": [
		"./src/components/ui/svgIcon/DeliveryBoxIcon copy.js",
		9,
		"src_components_ui_svgIcon_DeliveryBoxIcon_copy_js"
	],
	"./DeliveryBoxIcon copy.js": [
		"./src/components/ui/svgIcon/DeliveryBoxIcon copy.js",
		9,
		"src_components_ui_svgIcon_DeliveryBoxIcon_copy_js"
	],
	"./DeliveryBoxIcon.js": [
		"./src/components/ui/svgIcon/DeliveryBoxIcon.js",
		9,
		"src_components_ui_svgIcon_DeliveryBoxIcon_js"
	],
	"./DeliveryBoxesIcon": [
		"./src/components/ui/svgIcon/DeliveryBoxesIcon.js",
		9,
		"src_components_ui_svgIcon_DeliveryBoxesIcon_js"
	],
	"./DeliveryBoxesIcon.js": [
		"./src/components/ui/svgIcon/DeliveryBoxesIcon.js",
		9,
		"src_components_ui_svgIcon_DeliveryBoxesIcon_js"
	],
	"./DockerIcon": [
		"./src/components/ui/svgIcon/DockerIcon.js",
		9,
		"src_components_ui_svgIcon_DockerIcon_js"
	],
	"./DockerIcon.js": [
		"./src/components/ui/svgIcon/DockerIcon.js",
		9,
		"src_components_ui_svgIcon_DockerIcon_js"
	],
	"./DocumentCheckIcon": [
		"./src/components/ui/svgIcon/DocumentCheckIcon.js",
		9,
		"src_components_ui_svgIcon_DocumentCheckIcon_js"
	],
	"./DocumentCheckIcon.js": [
		"./src/components/ui/svgIcon/DocumentCheckIcon.js",
		9,
		"src_components_ui_svgIcon_DocumentCheckIcon_js"
	],
	"./DocumentDownloadIcon": [
		"./src/components/ui/svgIcon/DocumentDownloadIcon.js",
		9,
		"src_components_ui_svgIcon_DocumentDownloadIcon_js"
	],
	"./DocumentDownloadIcon.js": [
		"./src/components/ui/svgIcon/DocumentDownloadIcon.js",
		9,
		"src_components_ui_svgIcon_DocumentDownloadIcon_js"
	],
	"./DocumentIcon": [
		"./src/components/ui/svgIcon/DocumentIcon.js",
		9,
		"src_components_ui_svgIcon_DocumentIcon_js"
	],
	"./DocumentIcon.js": [
		"./src/components/ui/svgIcon/DocumentIcon.js",
		9,
		"src_components_ui_svgIcon_DocumentIcon_js"
	],
	"./DocumentInfinityIcon": [
		"./src/components/ui/svgIcon/DocumentInfinityIcon.js",
		9,
		"src_components_ui_svgIcon_DocumentInfinityIcon_js"
	],
	"./DocumentInfinityIcon.js": [
		"./src/components/ui/svgIcon/DocumentInfinityIcon.js",
		9,
		"src_components_ui_svgIcon_DocumentInfinityIcon_js"
	],
	"./DocumentPencilIcon": [
		"./src/components/ui/svgIcon/DocumentPencilIcon.js",
		9,
		"src_components_ui_svgIcon_DocumentPencilIcon_js"
	],
	"./DocumentPencilIcon.js": [
		"./src/components/ui/svgIcon/DocumentPencilIcon.js",
		9,
		"src_components_ui_svgIcon_DocumentPencilIcon_js"
	],
	"./DocumentVerifiedIcon": [
		"./src/components/ui/svgIcon/DocumentVerifiedIcon.js",
		9,
		"src_components_ui_svgIcon_DocumentVerifiedIcon_js"
	],
	"./DocumentVerifiedIcon.js": [
		"./src/components/ui/svgIcon/DocumentVerifiedIcon.js",
		9,
		"src_components_ui_svgIcon_DocumentVerifiedIcon_js"
	],
	"./DocumentsIcon": [
		"./src/components/ui/svgIcon/DocumentsIcon.js",
		9,
		"src_components_ui_svgIcon_DocumentsIcon_js-_c28410"
	],
	"./DocumentsIcon.js": [
		"./src/components/ui/svgIcon/DocumentsIcon.js",
		9,
		"src_components_ui_svgIcon_DocumentsIcon_js-_c28410"
	],
	"./Download2Icon": [
		"./src/components/ui/svgIcon/Download2Icon.js",
		9,
		"src_components_ui_svgIcon_Download2Icon_js"
	],
	"./Download2Icon.js": [
		"./src/components/ui/svgIcon/Download2Icon.js",
		9,
		"src_components_ui_svgIcon_Download2Icon_js"
	],
	"./DownloadIcon": [
		"./src/components/ui/svgIcon/DownloadIcon.js",
		9
	],
	"./DownloadIcon.js": [
		"./src/components/ui/svgIcon/DownloadIcon.js",
		9
	],
	"./DrinkingFilterPurificationIcon": [
		"./src/components/ui/svgIcon/DrinkingFilterPurificationIcon.js",
		9,
		"src_components_ui_svgIcon_DrinkingFilterPurificationIcon_js"
	],
	"./DrinkingFilterPurificationIcon.js": [
		"./src/components/ui/svgIcon/DrinkingFilterPurificationIcon.js",
		9,
		"src_components_ui_svgIcon_DrinkingFilterPurificationIcon_js"
	],
	"./DropboxIcon": [
		"./src/components/ui/svgIcon/DropboxIcon.js",
		9,
		"src_components_ui_svgIcon_DropboxIcon_js"
	],
	"./DropboxIcon.js": [
		"./src/components/ui/svgIcon/DropboxIcon.js",
		9,
		"src_components_ui_svgIcon_DropboxIcon_js"
	],
	"./EditIcon": [
		"./src/components/ui/svgIcon/EditIcon.js",
		9
	],
	"./EditIcon.js": [
		"./src/components/ui/svgIcon/EditIcon.js",
		9
	],
	"./EmailIcon": [
		"./src/components/ui/svgIcon/EmailIcon.js",
		9,
		"src_components_ui_svgIcon_EmailIcon_js"
	],
	"./EmailIcon.js": [
		"./src/components/ui/svgIcon/EmailIcon.js",
		9,
		"src_components_ui_svgIcon_EmailIcon_js"
	],
	"./EyeIcon": [
		"./src/components/ui/svgIcon/EyeIcon.js",
		9
	],
	"./EyeIcon.js": [
		"./src/components/ui/svgIcon/EyeIcon.js",
		9
	],
	"./FaceBookIcon": [
		"./src/components/ui/svgIcon/FaceBookIcon.js",
		9,
		"src_components_ui_svgIcon_FaceBookIcon_js"
	],
	"./FaceBookIcon.js": [
		"./src/components/ui/svgIcon/FaceBookIcon.js",
		9,
		"src_components_ui_svgIcon_FaceBookIcon_js"
	],
	"./FeatherFillIcon": [
		"./src/components/ui/svgIcon/FeatherFillIcon.js",
		9,
		"src_components_ui_svgIcon_FeatherFillIcon_js"
	],
	"./FeatherFillIcon.js": [
		"./src/components/ui/svgIcon/FeatherFillIcon.js",
		9,
		"src_components_ui_svgIcon_FeatherFillIcon_js"
	],
	"./FilterIcon": [
		"./src/components/ui/svgIcon/FilterIcon.js",
		9
	],
	"./FilterIcon.js": [
		"./src/components/ui/svgIcon/FilterIcon.js",
		9
	],
	"./FishBoneIcon": [
		"./src/components/ui/svgIcon/FishBoneIcon.js",
		9,
		"src_components_ui_svgIcon_FishBoneIcon_js"
	],
	"./FishBoneIcon.js": [
		"./src/components/ui/svgIcon/FishBoneIcon.js",
		9,
		"src_components_ui_svgIcon_FishBoneIcon_js"
	],
	"./FlagFilledIcon": [
		"./src/components/ui/svgIcon/FlagFilledIcon.js",
		9,
		"src_components_ui_svgIcon_FlagFilledIcon_js"
	],
	"./FlagFilledIcon.js": [
		"./src/components/ui/svgIcon/FlagFilledIcon.js",
		9,
		"src_components_ui_svgIcon_FlagFilledIcon_js"
	],
	"./FlagIcon": [
		"./src/components/ui/svgIcon/FlagIcon.js",
		9,
		"src_components_ui_svgIcon_FlagIcon_js"
	],
	"./FlagIcon.js": [
		"./src/components/ui/svgIcon/FlagIcon.js",
		9,
		"src_components_ui_svgIcon_FlagIcon_js"
	],
	"./FolderFileZipIcon": [
		"./src/components/ui/svgIcon/FolderFileZipIcon.js",
		9,
		"src_components_ui_svgIcon_FolderFileZipIcon_js"
	],
	"./FolderFileZipIcon.js": [
		"./src/components/ui/svgIcon/FolderFileZipIcon.js",
		9,
		"src_components_ui_svgIcon_FolderFileZipIcon_js"
	],
	"./FridgeIcon": [
		"./src/components/ui/svgIcon/FridgeIcon.js",
		9,
		"src_components_ui_svgIcon_FridgeIcon_js"
	],
	"./FridgeIcon.js": [
		"./src/components/ui/svgIcon/FridgeIcon.js",
		9,
		"src_components_ui_svgIcon_FridgeIcon_js"
	],
	"./GPSIcon": [
		"./src/components/ui/svgIcon/GPSIcon.js",
		9,
		"src_components_ui_svgIcon_GPSIcon_js"
	],
	"./GPSIcon.js": [
		"./src/components/ui/svgIcon/GPSIcon.js",
		9,
		"src_components_ui_svgIcon_GPSIcon_js"
	],
	"./GmailIcon": [
		"./src/components/ui/svgIcon/GmailIcon.js",
		9,
		"src_components_ui_svgIcon_GmailIcon_js"
	],
	"./GmailIcon.js": [
		"./src/components/ui/svgIcon/GmailIcon.js",
		9,
		"src_components_ui_svgIcon_GmailIcon_js"
	],
	"./Graduated": [
		"./src/components/ui/svgIcon/Graduated.js",
		9
	],
	"./Graduated.js": [
		"./src/components/ui/svgIcon/Graduated.js",
		9
	],
	"./GraduatedIcon": [
		"./src/components/ui/svgIcon/GraduatedIcon.js",
		9,
		"src_components_ui_svgIcon_GraduatedIcon_js"
	],
	"./GraduatedIcon.js": [
		"./src/components/ui/svgIcon/GraduatedIcon.js",
		9,
		"src_components_ui_svgIcon_GraduatedIcon_js"
	],
	"./GreenCheckmarkIcon": [
		"./src/components/ui/svgIcon/GreenCheckmarkIcon.js",
		9,
		"src_components_ui_svgIcon_GreenCheckmarkIcon_js"
	],
	"./GreenCheckmarkIcon.js": [
		"./src/components/ui/svgIcon/GreenCheckmarkIcon.js",
		9,
		"src_components_ui_svgIcon_GreenCheckmarkIcon_js"
	],
	"./GroupUsersIcon": [
		"./src/components/ui/svgIcon/GroupUsersIcon.js",
		9,
		"src_components_ui_svgIcon_GroupUsersIcon_js"
	],
	"./GroupUsersIcon.js": [
		"./src/components/ui/svgIcon/GroupUsersIcon.js",
		9,
		"src_components_ui_svgIcon_GroupUsersIcon_js"
	],
	"./HeadPhoneChargeIcon": [
		"./src/components/ui/svgIcon/HeadPhoneChargeIcon.js",
		9,
		"src_components_ui_svgIcon_HeadPhoneChargeIcon_js"
	],
	"./HeadPhoneChargeIcon.js": [
		"./src/components/ui/svgIcon/HeadPhoneChargeIcon.js",
		9,
		"src_components_ui_svgIcon_HeadPhoneChargeIcon_js"
	],
	"./HeadPhoneIcon": [
		"./src/components/ui/svgIcon/HeadPhoneIcon.js",
		9,
		"src_components_ui_svgIcon_HeadPhoneIcon_js"
	],
	"./HeadPhoneIcon.js": [
		"./src/components/ui/svgIcon/HeadPhoneIcon.js",
		9,
		"src_components_ui_svgIcon_HeadPhoneIcon_js"
	],
	"./HeaderLine_ico": [
		"./src/components/ui/svgIcon/HeaderLine_ico.js",
		9,
		"src_components_ui_svgIcon_HeaderLine_ico_js"
	],
	"./HeaderLine_ico.js": [
		"./src/components/ui/svgIcon/HeaderLine_ico.js",
		9,
		"src_components_ui_svgIcon_HeaderLine_ico_js"
	],
	"./HelpIcon": [
		"./src/components/ui/svgIcon/HelpIcon.js",
		9
	],
	"./HelpIcon.js": [
		"./src/components/ui/svgIcon/HelpIcon.js",
		9
	],
	"./HideEyeIcon": [
		"./src/components/ui/svgIcon/HideEyeIcon.js",
		9
	],
	"./HideEyeIcon.js": [
		"./src/components/ui/svgIcon/HideEyeIcon.js",
		9
	],
	"./HomeEmptyIcon": [
		"./src/components/ui/svgIcon/HomeEmptyIcon.js",
		9,
		"src_components_ui_svgIcon_HomeEmptyIcon_js"
	],
	"./HomeEmptyIcon.js": [
		"./src/components/ui/svgIcon/HomeEmptyIcon.js",
		9,
		"src_components_ui_svgIcon_HomeEmptyIcon_js"
	],
	"./HomeFillIcon": [
		"./src/components/ui/svgIcon/HomeFillIcon.js",
		9,
		"src_components_ui_svgIcon_HomeFillIcon_js"
	],
	"./HomeFillIcon.js": [
		"./src/components/ui/svgIcon/HomeFillIcon.js",
		9,
		"src_components_ui_svgIcon_HomeFillIcon_js"
	],
	"./HomeIcon": [
		"./src/components/ui/svgIcon/HomeIcon.js",
		9,
		"src_components_ui_svgIcon_HomeIcon_js"
	],
	"./HomeIcon.js": [
		"./src/components/ui/svgIcon/HomeIcon.js",
		9,
		"src_components_ui_svgIcon_HomeIcon_js"
	],
	"./HomeOutlineIcon": [
		"./src/components/ui/svgIcon/HomeOutlineIcon.js",
		9,
		"src_components_ui_svgIcon_HomeOutlineIcon_js"
	],
	"./HomeOutlineIcon.js": [
		"./src/components/ui/svgIcon/HomeOutlineIcon.js",
		9,
		"src_components_ui_svgIcon_HomeOutlineIcon_js"
	],
	"./HomeShopIcon": [
		"./src/components/ui/svgIcon/HomeShopIcon.js",
		9,
		"src_components_ui_svgIcon_HomeShopIcon_js"
	],
	"./HomeShopIcon.js": [
		"./src/components/ui/svgIcon/HomeShopIcon.js",
		9,
		"src_components_ui_svgIcon_HomeShopIcon_js"
	],
	"./HomeSlantedIcon": [
		"./src/components/ui/svgIcon/HomeSlantedIcon.js",
		9,
		"src_components_ui_svgIcon_HomeSlantedIcon_js"
	],
	"./HomeSlantedIcon.js": [
		"./src/components/ui/svgIcon/HomeSlantedIcon.js",
		9,
		"src_components_ui_svgIcon_HomeSlantedIcon_js"
	],
	"./IndicatorsIcon": [
		"./src/components/ui/svgIcon/IndicatorsIcon.js",
		9,
		"src_components_ui_svgIcon_IndicatorsIcon_js"
	],
	"./IndicatorsIcon.js": [
		"./src/components/ui/svgIcon/IndicatorsIcon.js",
		9,
		"src_components_ui_svgIcon_IndicatorsIcon_js"
	],
	"./InfoCircle": [
		"./src/components/ui/svgIcon/InfoCircle.js",
		9
	],
	"./InfoCircle.js": [
		"./src/components/ui/svgIcon/InfoCircle.js",
		9
	],
	"./InfoCircleFillIcon": [
		"./src/components/ui/svgIcon/InfoCircleFillIcon.js",
		9,
		"src_components_ui_svgIcon_InfoCircleFillIcon_js-_a55747"
	],
	"./InfoCircleFillIcon.js": [
		"./src/components/ui/svgIcon/InfoCircleFillIcon.js",
		9,
		"src_components_ui_svgIcon_InfoCircleFillIcon_js-_a55747"
	],
	"./InfoCircleIcon": [
		"./src/components/ui/svgIcon/InfoCircleIcon.js",
		9,
		"src_components_ui_svgIcon_InfoCircleIcon_js-_c37018"
	],
	"./InfoCircleIcon.js": [
		"./src/components/ui/svgIcon/InfoCircleIcon.js",
		9,
		"src_components_ui_svgIcon_InfoCircleIcon_js-_c37018"
	],
	"./InfoMenuIcon": [
		"./src/components/ui/svgIcon/InfoMenuIcon.js",
		9,
		"src_components_ui_svgIcon_InfoMenuIcon_js"
	],
	"./InfoMenuIcon.js": [
		"./src/components/ui/svgIcon/InfoMenuIcon.js",
		9,
		"src_components_ui_svgIcon_InfoMenuIcon_js"
	],
	"./InfoSquareIcon": [
		"./src/components/ui/svgIcon/InfoSquareIcon.js",
		9,
		"src_components_ui_svgIcon_InfoSquareIcon_js"
	],
	"./InfoSquareIcon.js": [
		"./src/components/ui/svgIcon/InfoSquareIcon.js",
		9,
		"src_components_ui_svgIcon_InfoSquareIcon_js"
	],
	"./InformationIcon": [
		"./src/components/ui/svgIcon/InformationIcon.js",
		9,
		"src_components_ui_svgIcon_InformationIcon_js"
	],
	"./InformationIcon.js": [
		"./src/components/ui/svgIcon/InformationIcon.js",
		9,
		"src_components_ui_svgIcon_InformationIcon_js"
	],
	"./InstagramIcon": [
		"./src/components/ui/svgIcon/InstagramIcon.js",
		9,
		"src_components_ui_svgIcon_InstagramIcon_js"
	],
	"./InstagramIcon.js": [
		"./src/components/ui/svgIcon/InstagramIcon.js",
		9,
		"src_components_ui_svgIcon_InstagramIcon_js"
	],
	"./InternetServerIcon": [
		"./src/components/ui/svgIcon/InternetServerIcon.js",
		9,
		"src_components_ui_svgIcon_InternetServerIcon_js"
	],
	"./InternetServerIcon.js": [
		"./src/components/ui/svgIcon/InternetServerIcon.js",
		9,
		"src_components_ui_svgIcon_InternetServerIcon_js"
	],
	"./JourneyIcon": [
		"./src/components/ui/svgIcon/JourneyIcon.js",
		9,
		"src_components_ui_svgIcon_JourneyIcon_js"
	],
	"./JourneyIcon.js": [
		"./src/components/ui/svgIcon/JourneyIcon.js",
		9,
		"src_components_ui_svgIcon_JourneyIcon_js"
	],
	"./KettleBellIcon": [
		"./src/components/ui/svgIcon/KettleBellIcon.js",
		9,
		"src_components_ui_svgIcon_KettleBellIcon_js"
	],
	"./KettleBellIcon.js": [
		"./src/components/ui/svgIcon/KettleBellIcon.js",
		9,
		"src_components_ui_svgIcon_KettleBellIcon_js"
	],
	"./KeyIcon": [
		"./src/components/ui/svgIcon/KeyIcon.js",
		9,
		"src_components_ui_svgIcon_KeyIcon_js"
	],
	"./KeyIcon.js": [
		"./src/components/ui/svgIcon/KeyIcon.js",
		9,
		"src_components_ui_svgIcon_KeyIcon_js"
	],
	"./KitchenHatIcon": [
		"./src/components/ui/svgIcon/KitchenHatIcon.js",
		9,
		"src_components_ui_svgIcon_KitchenHatIcon_js"
	],
	"./KitchenHatIcon.js": [
		"./src/components/ui/svgIcon/KitchenHatIcon.js",
		9,
		"src_components_ui_svgIcon_KitchenHatIcon_js"
	],
	"./LandScapeIcon": [
		"./src/components/ui/svgIcon/LandScapeIcon.js",
		9,
		"src_components_ui_svgIcon_LandScapeIcon_js"
	],
	"./LandScapeIcon.js": [
		"./src/components/ui/svgIcon/LandScapeIcon.js",
		9,
		"src_components_ui_svgIcon_LandScapeIcon_js"
	],
	"./LinkFillIcon": [
		"./src/components/ui/svgIcon/LinkFillIcon.js",
		9,
		"src_components_ui_svgIcon_LinkFillIcon_js"
	],
	"./LinkFillIcon.js": [
		"./src/components/ui/svgIcon/LinkFillIcon.js",
		9,
		"src_components_ui_svgIcon_LinkFillIcon_js"
	],
	"./LinkIcon": [
		"./src/components/ui/svgIcon/LinkIcon.js",
		9
	],
	"./LinkIcon.js": [
		"./src/components/ui/svgIcon/LinkIcon.js",
		9
	],
	"./LinkOutLineIcon": [
		"./src/components/ui/svgIcon/LinkOutLineIcon.js",
		9,
		"src_components_ui_svgIcon_LinkOutLineIcon_js-_403c5"
	],
	"./LinkOutLineIcon.js": [
		"./src/components/ui/svgIcon/LinkOutLineIcon.js",
		9,
		"src_components_ui_svgIcon_LinkOutLineIcon_js-_403c5"
	],
	"./LiqualityIcon": [
		"./src/components/ui/svgIcon/LiqualityIcon.js",
		9,
		"src_components_ui_svgIcon_LiqualityIcon_js"
	],
	"./LiqualityIcon.js": [
		"./src/components/ui/svgIcon/LiqualityIcon.js",
		9,
		"src_components_ui_svgIcon_LiqualityIcon_js"
	],
	"./LoadingCircle": [
		"./src/components/ui/svgIcon/LoadingCircle.js",
		9,
		"src_components_ui_svgIcon_LoadingCircle_js"
	],
	"./LoadingCircle.js": [
		"./src/components/ui/svgIcon/LoadingCircle.js",
		9,
		"src_components_ui_svgIcon_LoadingCircle_js"
	],
	"./LoadingCircle2Icon": [
		"./src/components/ui/svgIcon/LoadingCircle2Icon.js",
		9,
		"src_components_ui_svgIcon_LoadingCircle2Icon_js"
	],
	"./LoadingCircle2Icon.js": [
		"./src/components/ui/svgIcon/LoadingCircle2Icon.js",
		9,
		"src_components_ui_svgIcon_LoadingCircle2Icon_js"
	],
	"./LocationIcon": [
		"./src/components/ui/svgIcon/LocationIcon.js",
		9,
		"src_components_ui_svgIcon_LocationIcon_js"
	],
	"./LocationIcon.js": [
		"./src/components/ui/svgIcon/LocationIcon.js",
		9,
		"src_components_ui_svgIcon_LocationIcon_js"
	],
	"./LockCheckIcon": [
		"./src/components/ui/svgIcon/LockCheckIcon.js",
		9,
		"src_components_ui_svgIcon_LockCheckIcon_js"
	],
	"./LockCheckIcon.js": [
		"./src/components/ui/svgIcon/LockCheckIcon.js",
		9,
		"src_components_ui_svgIcon_LockCheckIcon_js"
	],
	"./LockOpenIcon": [
		"./src/components/ui/svgIcon/LockOpenIcon.js",
		9,
		"src_components_ui_svgIcon_LockOpenIcon_js"
	],
	"./LockOpenIcon.js": [
		"./src/components/ui/svgIcon/LockOpenIcon.js",
		9,
		"src_components_ui_svgIcon_LockOpenIcon_js"
	],
	"./LogoutIcon": [
		"./src/components/ui/svgIcon/LogoutIcon.js",
		9,
		"src_components_ui_svgIcon_LogoutIcon_js"
	],
	"./LogoutIcon.js": [
		"./src/components/ui/svgIcon/LogoutIcon.js",
		9,
		"src_components_ui_svgIcon_LogoutIcon_js"
	],
	"./MapIcon": [
		"./src/components/ui/svgIcon/MapIcon.js",
		9,
		"src_components_ui_svgIcon_MapIcon_js"
	],
	"./MapIcon.js": [
		"./src/components/ui/svgIcon/MapIcon.js",
		9,
		"src_components_ui_svgIcon_MapIcon_js"
	],
	"./Medal1Icon": [
		"./src/components/ui/svgIcon/Medal1Icon.js",
		9,
		"src_components_ui_svgIcon_Medal1Icon_js"
	],
	"./Medal1Icon.js": [
		"./src/components/ui/svgIcon/Medal1Icon.js",
		9,
		"src_components_ui_svgIcon_Medal1Icon_js"
	],
	"./MedalIcon": [
		"./src/components/ui/svgIcon/MedalIcon.js",
		9,
		"src_components_ui_svgIcon_MedalIcon_js"
	],
	"./MedalIcon.js": [
		"./src/components/ui/svgIcon/MedalIcon.js",
		9,
		"src_components_ui_svgIcon_MedalIcon_js"
	],
	"./MedicalCallIcon": [
		"./src/components/ui/svgIcon/MedicalCallIcon.js",
		9
	],
	"./MedicalCallIcon.js": [
		"./src/components/ui/svgIcon/MedicalCallIcon.js",
		9
	],
	"./MessagesBubbleIcon": [
		"./src/components/ui/svgIcon/MessagesBubbleIcon.js",
		9,
		"src_components_ui_svgIcon_MessagesBubbleIcon_js"
	],
	"./MessagesBubbleIcon.js": [
		"./src/components/ui/svgIcon/MessagesBubbleIcon.js",
		9,
		"src_components_ui_svgIcon_MessagesBubbleIcon_js"
	],
	"./MicrobeIcon": [
		"./src/components/ui/svgIcon/MicrobeIcon.jsx",
		9,
		"src_components_ui_svgIcon_MicrobeIcon_jsx"
	],
	"./MicrobeIcon.jsx": [
		"./src/components/ui/svgIcon/MicrobeIcon.jsx",
		9,
		"src_components_ui_svgIcon_MicrobeIcon_jsx"
	],
	"./MinusIcon": [
		"./src/components/ui/svgIcon/MinusIcon.js",
		9,
		"src_components_ui_svgIcon_MinusIcon_js"
	],
	"./MinusIcon.js": [
		"./src/components/ui/svgIcon/MinusIcon.js",
		9,
		"src_components_ui_svgIcon_MinusIcon_js"
	],
	"./MoneyBagIcon": [
		"./src/components/ui/svgIcon/MoneyBagIcon.js",
		9,
		"src_components_ui_svgIcon_MoneyBagIcon_js"
	],
	"./MoneyBagIcon copy": [
		"./src/components/ui/svgIcon/MoneyBagIcon copy.js",
		9,
		"src_components_ui_svgIcon_MoneyBagIcon_copy_js"
	],
	"./MoneyBagIcon copy.js": [
		"./src/components/ui/svgIcon/MoneyBagIcon copy.js",
		9,
		"src_components_ui_svgIcon_MoneyBagIcon_copy_js"
	],
	"./MoneyBagIcon.js": [
		"./src/components/ui/svgIcon/MoneyBagIcon.js",
		9,
		"src_components_ui_svgIcon_MoneyBagIcon_js"
	],
	"./MonitorIcon": [
		"./src/components/ui/svgIcon/MonitorIcon.js",
		9,
		"src_components_ui_svgIcon_MonitorIcon_js"
	],
	"./MonitorIcon.js": [
		"./src/components/ui/svgIcon/MonitorIcon.js",
		9,
		"src_components_ui_svgIcon_MonitorIcon_js"
	],
	"./MoreCircleIcon": [
		"./src/components/ui/svgIcon/MoreCircleIcon.js",
		9,
		"src_components_ui_svgIcon_MoreCircleIcon_js"
	],
	"./MoreCircleIcon.js": [
		"./src/components/ui/svgIcon/MoreCircleIcon.js",
		9,
		"src_components_ui_svgIcon_MoreCircleIcon_js"
	],
	"./NoFilterIcon": [
		"./src/components/ui/svgIcon/NoFilterIcon.js",
		9,
		"src_components_ui_svgIcon_NoFilterIcon_js"
	],
	"./NoFilterIcon.js": [
		"./src/components/ui/svgIcon/NoFilterIcon.js",
		9,
		"src_components_ui_svgIcon_NoFilterIcon_js"
	],
	"./NoteBookSearch": [
		"./src/components/ui/svgIcon/NoteBookSearch.js",
		9,
		"src_components_ui_svgIcon_NoteBookSearch_js"
	],
	"./NoteBookSearch.js": [
		"./src/components/ui/svgIcon/NoteBookSearch.js",
		9,
		"src_components_ui_svgIcon_NoteBookSearch_js"
	],
	"./NotificationIcon": [
		"./src/components/ui/svgIcon/NotificationIcon.js",
		9,
		"src_components_ui_svgIcon_NotificationIcon_js"
	],
	"./NotificationIcon.js": [
		"./src/components/ui/svgIcon/NotificationIcon.js",
		9,
		"src_components_ui_svgIcon_NotificationIcon_js"
	],
	"./NumberedListIcon": [
		"./src/components/ui/svgIcon/NumberedListIcon.js",
		9,
		"src_components_ui_svgIcon_NumberedListIcon_js"
	],
	"./NumberedListIcon.js": [
		"./src/components/ui/svgIcon/NumberedListIcon.js",
		9,
		"src_components_ui_svgIcon_NumberedListIcon_js"
	],
	"./OceanIcon": [
		"./src/components/ui/svgIcon/OceanIcon.js",
		9,
		"src_components_ui_svgIcon_OceanIcon_js"
	],
	"./OceanIcon.js": [
		"./src/components/ui/svgIcon/OceanIcon.js",
		9,
		"src_components_ui_svgIcon_OceanIcon_js"
	],
	"./PaperIcon": [
		"./src/components/ui/svgIcon/PaperIcon.js",
		9,
		"src_components_ui_svgIcon_PaperIcon_js"
	],
	"./PaperIcon.js": [
		"./src/components/ui/svgIcon/PaperIcon.js",
		9,
		"src_components_ui_svgIcon_PaperIcon_js"
	],
	"./PaperUploadIcon": [
		"./src/components/ui/svgIcon/PaperUploadIcon.js",
		9,
		"src_components_ui_svgIcon_PaperUploadIcon_js"
	],
	"./PaperUploadIcon.js": [
		"./src/components/ui/svgIcon/PaperUploadIcon.js",
		9,
		"src_components_ui_svgIcon_PaperUploadIcon_js"
	],
	"./PhoneFillIcon": [
		"./src/components/ui/svgIcon/PhoneFillIcon.js",
		9,
		"src_components_ui_svgIcon_PhoneFillIcon_js"
	],
	"./PhoneFillIcon.js": [
		"./src/components/ui/svgIcon/PhoneFillIcon.js",
		9,
		"src_components_ui_svgIcon_PhoneFillIcon_js"
	],
	"./PhoneIcon": [
		"./src/components/ui/svgIcon/PhoneIcon.js",
		9,
		"src_components_ui_svgIcon_PhoneIcon_js"
	],
	"./PhoneIcon.js": [
		"./src/components/ui/svgIcon/PhoneIcon.js",
		9,
		"src_components_ui_svgIcon_PhoneIcon_js"
	],
	"./PinIcon": [
		"./src/components/ui/svgIcon/PinIcon.js",
		9,
		"src_components_ui_svgIcon_PinIcon_js"
	],
	"./PinIcon.js": [
		"./src/components/ui/svgIcon/PinIcon.js",
		9,
		"src_components_ui_svgIcon_PinIcon_js"
	],
	"./PinMapIcon": [
		"./src/components/ui/svgIcon/PinMapIcon.js",
		9,
		"src_components_ui_svgIcon_PinMapIcon_js"
	],
	"./PinMapIcon.js": [
		"./src/components/ui/svgIcon/PinMapIcon.js",
		9,
		"src_components_ui_svgIcon_PinMapIcon_js"
	],
	"./PlaneLandingIcon": [
		"./src/components/ui/svgIcon/PlaneLandingIcon.jsx",
		9,
		"src_components_ui_svgIcon_PlaneLandingIcon_jsx"
	],
	"./PlaneLandingIcon.jsx": [
		"./src/components/ui/svgIcon/PlaneLandingIcon.jsx",
		9,
		"src_components_ui_svgIcon_PlaneLandingIcon_jsx"
	],
	"./PlusIcon": [
		"./src/components/ui/svgIcon/PlusIcon.js",
		9
	],
	"./PlusIcon.js": [
		"./src/components/ui/svgIcon/PlusIcon.js",
		9
	],
	"./PlusSqreIcon": [
		"./src/components/ui/svgIcon/PlusSqreIcon.js",
		9,
		"src_components_ui_svgIcon_PlusSqreIcon_js"
	],
	"./PlusSqreIcon.js": [
		"./src/components/ui/svgIcon/PlusSqreIcon.js",
		9,
		"src_components_ui_svgIcon_PlusSqreIcon_js"
	],
	"./PlusSquareIcon": [
		"./src/components/ui/svgIcon/PlusSquareIcon.js",
		9,
		"src_components_ui_svgIcon_PlusSquareIcon_js"
	],
	"./PlusSquareIcon.js": [
		"./src/components/ui/svgIcon/PlusSquareIcon.js",
		9,
		"src_components_ui_svgIcon_PlusSquareIcon_js"
	],
	"./PowerAdapterChargeOutputIcon": [
		"./src/components/ui/svgIcon/PowerAdapterChargeOutputIcon.js",
		9,
		"src_components_ui_svgIcon_PowerAdapterChargeOutputIcon_js"
	],
	"./PowerAdapterChargeOutputIcon.js": [
		"./src/components/ui/svgIcon/PowerAdapterChargeOutputIcon.js",
		9,
		"src_components_ui_svgIcon_PowerAdapterChargeOutputIcon_js"
	],
	"./PrinterIcon": [
		"./src/components/ui/svgIcon/PrinterIcon.js",
		9,
		"src_components_ui_svgIcon_PrinterIcon_js"
	],
	"./PrinterIcon.js": [
		"./src/components/ui/svgIcon/PrinterIcon.js",
		9,
		"src_components_ui_svgIcon_PrinterIcon_js"
	],
	"./ProfileIcon": [
		"./src/components/ui/svgIcon/ProfileIcon.js",
		9,
		"src_components_ui_svgIcon_ProfileIcon_js"
	],
	"./ProfileIcon.js": [
		"./src/components/ui/svgIcon/ProfileIcon.js",
		9,
		"src_components_ui_svgIcon_ProfileIcon_js"
	],
	"./QuestionMarkFillIcon": [
		"./src/components/ui/svgIcon/QuestionMarkFillIcon.js",
		9,
		"src_components_ui_svgIcon_QuestionMarkFillIcon_js"
	],
	"./QuestionMarkFillIcon.js": [
		"./src/components/ui/svgIcon/QuestionMarkFillIcon.js",
		9,
		"src_components_ui_svgIcon_QuestionMarkFillIcon_js"
	],
	"./ReceiptBillClose": [
		"./src/components/ui/svgIcon/ReceiptBillClose.js",
		9,
		"src_components_ui_svgIcon_ReceiptBillClose_js"
	],
	"./ReceiptBillClose.js": [
		"./src/components/ui/svgIcon/ReceiptBillClose.js",
		9,
		"src_components_ui_svgIcon_ReceiptBillClose_js"
	],
	"./ReceiptBillIcon": [
		"./src/components/ui/svgIcon/ReceiptBillIcon.js",
		9,
		"src_components_ui_svgIcon_ReceiptBillIcon_js"
	],
	"./ReceiptBillIcon.js": [
		"./src/components/ui/svgIcon/ReceiptBillIcon.js",
		9,
		"src_components_ui_svgIcon_ReceiptBillIcon_js"
	],
	"./RedCrossIcon": [
		"./src/components/ui/svgIcon/RedCrossIcon.js",
		9,
		"src_components_ui_svgIcon_RedCrossIcon_js"
	],
	"./RedCrossIcon.js": [
		"./src/components/ui/svgIcon/RedCrossIcon.js",
		9,
		"src_components_ui_svgIcon_RedCrossIcon_js"
	],
	"./RefreshIcon": [
		"./src/components/ui/svgIcon/RefreshIcon.js",
		9
	],
	"./RefreshIcon.js": [
		"./src/components/ui/svgIcon/RefreshIcon.js",
		9
	],
	"./RemoveCircle": [
		"./src/components/ui/svgIcon/RemoveCircle.js",
		9
	],
	"./RemoveCircle.js": [
		"./src/components/ui/svgIcon/RemoveCircle.js",
		9
	],
	"./RemoveHexagonal": [
		"./src/components/ui/svgIcon/RemoveHexagonal.js",
		9,
		"src_components_ui_svgIcon_RemoveHexagonal_js"
	],
	"./RemoveHexagonal.js": [
		"./src/components/ui/svgIcon/RemoveHexagonal.js",
		9,
		"src_components_ui_svgIcon_RemoveHexagonal_js"
	],
	"./ReplayIcon": [
		"./src/components/ui/svgIcon/ReplayIcon.js",
		9,
		"src_components_ui_svgIcon_ReplayIcon_js"
	],
	"./ReplayIcon.js": [
		"./src/components/ui/svgIcon/ReplayIcon.js",
		9,
		"src_components_ui_svgIcon_ReplayIcon_js"
	],
	"./ReplySqreIcon": [
		"./src/components/ui/svgIcon/ReplySqreIcon.js",
		9,
		"src_components_ui_svgIcon_ReplySqreIcon_js"
	],
	"./ReplySqreIcon.js": [
		"./src/components/ui/svgIcon/ReplySqreIcon.js",
		9,
		"src_components_ui_svgIcon_ReplySqreIcon_js"
	],
	"./ResizeIcon": [
		"./src/components/ui/svgIcon/ResizeIcon.js",
		9,
		"src_components_ui_svgIcon_ResizeIcon_js"
	],
	"./ResizeIcon.js": [
		"./src/components/ui/svgIcon/ResizeIcon.js",
		9,
		"src_components_ui_svgIcon_ResizeIcon_js"
	],
	"./RicePlateIcon": [
		"./src/components/ui/svgIcon/RicePlateIcon.js",
		9,
		"src_components_ui_svgIcon_RicePlateIcon_js"
	],
	"./RicePlateIcon.js": [
		"./src/components/ui/svgIcon/RicePlateIcon.js",
		9,
		"src_components_ui_svgIcon_RicePlateIcon_js"
	],
	"./RightUpBox3Icon": [
		"./src/components/ui/svgIcon/RightUpBox3Icon.js",
		9,
		"src_components_ui_svgIcon_RightUpBox3Icon_js"
	],
	"./RightUpBox3Icon.js": [
		"./src/components/ui/svgIcon/RightUpBox3Icon.js",
		9,
		"src_components_ui_svgIcon_RightUpBox3Icon_js"
	],
	"./RoubikaIcon": [
		"./src/components/ui/svgIcon/RoubikaIcon.js",
		9,
		"src_components_ui_svgIcon_RoubikaIcon_js"
	],
	"./RoubikaIcon.js": [
		"./src/components/ui/svgIcon/RoubikaIcon.js",
		9,
		"src_components_ui_svgIcon_RoubikaIcon_js"
	],
	"./SSOIcon": [
		"./src/components/ui/svgIcon/SSOIcon.js",
		9
	],
	"./SSOIcon.js": [
		"./src/components/ui/svgIcon/SSOIcon.js",
		9
	],
	"./ScanIcon": [
		"./src/components/ui/svgIcon/ScanIcon.js",
		9,
		"src_components_ui_svgIcon_ScanIcon_js"
	],
	"./ScanIcon.js": [
		"./src/components/ui/svgIcon/ScanIcon.js",
		9,
		"src_components_ui_svgIcon_ScanIcon_js"
	],
	"./ScrollListIcon": [
		"./src/components/ui/svgIcon/ScrollListIcon.js",
		9
	],
	"./ScrollListIcon.js": [
		"./src/components/ui/svgIcon/ScrollListIcon.js",
		9
	],
	"./SeaWaveFillIcon": [
		"./src/components/ui/svgIcon/SeaWaveFillIcon.js",
		9
	],
	"./SeaWaveFillIcon.js": [
		"./src/components/ui/svgIcon/SeaWaveFillIcon.js",
		9
	],
	"./SeaWaveIcon": [
		"./src/components/ui/svgIcon/SeaWaveIcon.js",
		9,
		"src_components_ui_svgIcon_SeaWaveIcon_js"
	],
	"./SeaWaveIcon.js": [
		"./src/components/ui/svgIcon/SeaWaveIcon.js",
		9,
		"src_components_ui_svgIcon_SeaWaveIcon_js"
	],
	"./SearchExploreIcon": [
		"./src/components/ui/svgIcon/SearchExploreIcon.js",
		9,
		"src_components_ui_svgIcon_SearchExploreIcon_js"
	],
	"./SearchExploreIcon.js": [
		"./src/components/ui/svgIcon/SearchExploreIcon.js",
		9,
		"src_components_ui_svgIcon_SearchExploreIcon_js"
	],
	"./SearchIcon": [
		"./src/components/ui/svgIcon/SearchIcon.js",
		9
	],
	"./SearchIcon.js": [
		"./src/components/ui/svgIcon/SearchIcon.js",
		9
	],
	"./SearchMoneyDollarIcon": [
		"./src/components/ui/svgIcon/SearchMoneyDollarIcon.js",
		9,
		"src_components_ui_svgIcon_SearchMoneyDollarIcon_js"
	],
	"./SearchMoneyDollarIcon.js": [
		"./src/components/ui/svgIcon/SearchMoneyDollarIcon.js",
		9,
		"src_components_ui_svgIcon_SearchMoneyDollarIcon_js"
	],
	"./SendIcon": [
		"./src/components/ui/svgIcon/SendIcon.js",
		9,
		"src_components_ui_svgIcon_SendIcon_js"
	],
	"./SendIcon.js": [
		"./src/components/ui/svgIcon/SendIcon.js",
		9,
		"src_components_ui_svgIcon_SendIcon_js"
	],
	"./ServerCloudIcon": [
		"./src/components/ui/svgIcon/ServerCloudIcon.js",
		9,
		"src_components_ui_svgIcon_ServerCloudIcon_js"
	],
	"./ServerCloudIcon.js": [
		"./src/components/ui/svgIcon/ServerCloudIcon.js",
		9,
		"src_components_ui_svgIcon_ServerCloudIcon_js"
	],
	"./ServerTreeIcon": [
		"./src/components/ui/svgIcon/ServerTreeIcon.js",
		9,
		"src_components_ui_svgIcon_ServerTreeIcon_js"
	],
	"./ServerTreeIcon.js": [
		"./src/components/ui/svgIcon/ServerTreeIcon.js",
		9,
		"src_components_ui_svgIcon_ServerTreeIcon_js"
	],
	"./SettingsFillIcon": [
		"./src/components/ui/svgIcon/SettingsFillIcon.js",
		9,
		"src_components_ui_svgIcon_SettingsFillIcon_js"
	],
	"./SettingsFillIcon.js": [
		"./src/components/ui/svgIcon/SettingsFillIcon.js",
		9,
		"src_components_ui_svgIcon_SettingsFillIcon_js"
	],
	"./SettingsIcon": [
		"./src/components/ui/svgIcon/SettingsIcon.js",
		9
	],
	"./SettingsIcon.js": [
		"./src/components/ui/svgIcon/SettingsIcon.js",
		9
	],
	"./ShieldDoneFillIcon": [
		"./src/components/ui/svgIcon/ShieldDoneFillIcon.js",
		9,
		"src_components_ui_svgIcon_ShieldDoneFillIcon_js"
	],
	"./ShieldDoneFillIcon.js": [
		"./src/components/ui/svgIcon/ShieldDoneFillIcon.js",
		9,
		"src_components_ui_svgIcon_ShieldDoneFillIcon_js"
	],
	"./ShieldProfileIcon": [
		"./src/components/ui/svgIcon/ShieldProfileIcon.js",
		9,
		"src_components_ui_svgIcon_ShieldProfileIcon_js"
	],
	"./ShieldProfileIcon.js": [
		"./src/components/ui/svgIcon/ShieldProfileIcon.js",
		9,
		"src_components_ui_svgIcon_ShieldProfileIcon_js"
	],
	"./ShipIcon": [
		"./src/components/ui/svgIcon/ShipIcon.js",
		9,
		"src_components_ui_svgIcon_ShipIcon_js"
	],
	"./ShipIcon.js": [
		"./src/components/ui/svgIcon/ShipIcon.js",
		9,
		"src_components_ui_svgIcon_ShipIcon_js"
	],
	"./SketchIcon": [
		"./src/components/ui/svgIcon/SketchIcon.js",
		9
	],
	"./SketchIcon.js": [
		"./src/components/ui/svgIcon/SketchIcon.js",
		9
	],
	"./SketchIcon2": [
		"./src/components/ui/svgIcon/SketchIcon2.js",
		9,
		"src_components_ui_svgIcon_SketchIcon2_js"
	],
	"./SketchIcon2.js": [
		"./src/components/ui/svgIcon/SketchIcon2.js",
		9,
		"src_components_ui_svgIcon_SketchIcon2_js"
	],
	"./SolarSystemIcon": [
		"./src/components/ui/svgIcon/SolarSystemIcon.js",
		9,
		"src_components_ui_svgIcon_SolarSystemIcon_js"
	],
	"./SolarSystemIcon.js": [
		"./src/components/ui/svgIcon/SolarSystemIcon.js",
		9,
		"src_components_ui_svgIcon_SolarSystemIcon_js"
	],
	"./SortCompleteIcon": [
		"./src/components/ui/svgIcon/SortCompleteIcon.js",
		9,
		"src_components_ui_svgIcon_SortCompleteIcon_js"
	],
	"./SortCompleteIcon.js": [
		"./src/components/ui/svgIcon/SortCompleteIcon.js",
		9,
		"src_components_ui_svgIcon_SortCompleteIcon_js"
	],
	"./SpeakerMegaphoneIcon": [
		"./src/components/ui/svgIcon/SpeakerMegaphoneIcon.js",
		9,
		"src_components_ui_svgIcon_SpeakerMegaphoneIcon_js"
	],
	"./SpeakerMegaphoneIcon.js": [
		"./src/components/ui/svgIcon/SpeakerMegaphoneIcon.js",
		9,
		"src_components_ui_svgIcon_SpeakerMegaphoneIcon_js"
	],
	"./SpermIcon": [
		"./src/components/ui/svgIcon/SpermIcon.jsx",
		9,
		"src_components_ui_svgIcon_SpermIcon_jsx"
	],
	"./SpermIcon.jsx": [
		"./src/components/ui/svgIcon/SpermIcon.jsx",
		9,
		"src_components_ui_svgIcon_SpermIcon_jsx"
	],
	"./SquarearrowIcon": [
		"./src/components/ui/svgIcon/SquarearrowIcon.js",
		9,
		"src_components_ui_svgIcon_SquarearrowIcon_js"
	],
	"./SquarearrowIcon.js": [
		"./src/components/ui/svgIcon/SquarearrowIcon.js",
		9,
		"src_components_ui_svgIcon_SquarearrowIcon_js"
	],
	"./SquaresIcon": [
		"./src/components/ui/svgIcon/SquaresIcon.js",
		9,
		"src_components_ui_svgIcon_SquaresIcon_js"
	],
	"./SquaresIcon.js": [
		"./src/components/ui/svgIcon/SquaresIcon.js",
		9,
		"src_components_ui_svgIcon_SquaresIcon_js"
	],
	"./StarEmptyIcon": [
		"./src/components/ui/svgIcon/StarEmptyIcon.js",
		9,
		"src_components_ui_svgIcon_StarEmptyIcon_js"
	],
	"./StarEmptyIcon.js": [
		"./src/components/ui/svgIcon/StarEmptyIcon.js",
		9,
		"src_components_ui_svgIcon_StarEmptyIcon_js"
	],
	"./StarFillIcon": [
		"./src/components/ui/svgIcon/StarFillIcon.js",
		9,
		"src_components_ui_svgIcon_StarFillIcon_js"
	],
	"./StarFillIcon.js": [
		"./src/components/ui/svgIcon/StarFillIcon.js",
		9,
		"src_components_ui_svgIcon_StarFillIcon_js"
	],
	"./StarGlowing": [
		"./src/components/ui/svgIcon/StarGlowing.js",
		9,
		"src_components_ui_svgIcon_StarGlowing_js"
	],
	"./StarGlowing.js": [
		"./src/components/ui/svgIcon/StarGlowing.js",
		9,
		"src_components_ui_svgIcon_StarGlowing_js"
	],
	"./StarIcon": [
		"./src/components/ui/svgIcon/StarIcon.js",
		9,
		"src_components_ui_svgIcon_StarIcon_js"
	],
	"./StarIcon.js": [
		"./src/components/ui/svgIcon/StarIcon.js",
		9,
		"src_components_ui_svgIcon_StarIcon_js"
	],
	"./SteemIcon": [
		"./src/components/ui/svgIcon/SteemIcon.jsx",
		9,
		"src_components_ui_svgIcon_SteemIcon_jsx"
	],
	"./SteemIcon.jsx": [
		"./src/components/ui/svgIcon/SteemIcon.jsx",
		9,
		"src_components_ui_svgIcon_SteemIcon_jsx"
	],
	"./StickerDocumentCloseIcon": [
		"./src/components/ui/svgIcon/StickerDocumentCloseIcon.js",
		9,
		"src_components_ui_svgIcon_StickerDocumentCloseIcon_js"
	],
	"./StickerDocumentCloseIcon.js": [
		"./src/components/ui/svgIcon/StickerDocumentCloseIcon.js",
		9,
		"src_components_ui_svgIcon_StickerDocumentCloseIcon_js"
	],
	"./SubscriptionIcon": [
		"./src/components/ui/svgIcon/SubscriptionIcon.js",
		9
	],
	"./SubscriptionIcon.js": [
		"./src/components/ui/svgIcon/SubscriptionIcon.js",
		9
	],
	"./SwapSquareVertical": [
		"./src/components/ui/svgIcon/SwapSquareVertical.js",
		9,
		"src_components_ui_svgIcon_SwapSquareVertical_js"
	],
	"./SwapSquareVertical.js": [
		"./src/components/ui/svgIcon/SwapSquareVertical.js",
		9,
		"src_components_ui_svgIcon_SwapSquareVertical_js"
	],
	"./TankCisternIcon": [
		"./src/components/ui/svgIcon/TankCisternIcon.js",
		9,
		"src_components_ui_svgIcon_TankCisternIcon_js"
	],
	"./TankCisternIcon.js": [
		"./src/components/ui/svgIcon/TankCisternIcon.js",
		9,
		"src_components_ui_svgIcon_TankCisternIcon_js"
	],
	"./TelephoneIcon": [
		"./src/components/ui/svgIcon/TelephoneIcon.js",
		9,
		"src_components_ui_svgIcon_TelephoneIcon_js"
	],
	"./TelephoneIcon.js": [
		"./src/components/ui/svgIcon/TelephoneIcon.js",
		9,
		"src_components_ui_svgIcon_TelephoneIcon_js"
	],
	"./TemperatureIcon": [
		"./src/components/ui/svgIcon/TemperatureIcon.js",
		9,
		"src_components_ui_svgIcon_TemperatureIcon_js"
	],
	"./TemperatureIcon.js": [
		"./src/components/ui/svgIcon/TemperatureIcon.js",
		9,
		"src_components_ui_svgIcon_TemperatureIcon_js"
	],
	"./ThermometerIcon": [
		"./src/components/ui/svgIcon/ThermometerIcon.js",
		9,
		"src_components_ui_svgIcon_ThermometerIcon_js"
	],
	"./ThermometerIcon.js": [
		"./src/components/ui/svgIcon/ThermometerIcon.js",
		9,
		"src_components_ui_svgIcon_ThermometerIcon_js"
	],
	"./TickFile": [
		"./src/components/ui/svgIcon/TickFile.js",
		9,
		"src_components_ui_svgIcon_TickFile_js"
	],
	"./TickFile.js": [
		"./src/components/ui/svgIcon/TickFile.js",
		9,
		"src_components_ui_svgIcon_TickFile_js"
	],
	"./TicketCloseIcon": [
		"./src/components/ui/svgIcon/TicketCloseIcon.js",
		9,
		"src_components_ui_svgIcon_TicketCloseIcon_js"
	],
	"./TicketCloseIcon.js": [
		"./src/components/ui/svgIcon/TicketCloseIcon.js",
		9,
		"src_components_ui_svgIcon_TicketCloseIcon_js"
	],
	"./TimeCircleIcon": [
		"./src/components/ui/svgIcon/TimeCircleIcon.js",
		9,
		"src_components_ui_svgIcon_TimeCircleIcon_js"
	],
	"./TimeCircleIcon.js": [
		"./src/components/ui/svgIcon/TimeCircleIcon.js",
		9,
		"src_components_ui_svgIcon_TimeCircleIcon_js"
	],
	"./ToolsIcon": [
		"./src/components/ui/svgIcon/ToolsIcon.js",
		9,
		"src_components_ui_svgIcon_ToolsIcon_js"
	],
	"./ToolsIcon.js": [
		"./src/components/ui/svgIcon/ToolsIcon.js",
		9,
		"src_components_ui_svgIcon_ToolsIcon_js"
	],
	"./TransactionsDownIcon": [
		"./src/components/ui/svgIcon/TransactionsDownIcon.js",
		9,
		"src_components_ui_svgIcon_TransactionsDownIcon_js"
	],
	"./TransactionsDownIcon.js": [
		"./src/components/ui/svgIcon/TransactionsDownIcon.js",
		9,
		"src_components_ui_svgIcon_TransactionsDownIcon_js"
	],
	"./TransactionsUpIcon": [
		"./src/components/ui/svgIcon/TransactionsUpIcon.js",
		9,
		"src_components_ui_svgIcon_TransactionsUpIcon_js"
	],
	"./TransactionsUpIcon.js": [
		"./src/components/ui/svgIcon/TransactionsUpIcon.js",
		9,
		"src_components_ui_svgIcon_TransactionsUpIcon_js"
	],
	"./TreeDiagramIcon": [
		"./src/components/ui/svgIcon/TreeDiagramIcon.js",
		9,
		"src_components_ui_svgIcon_TreeDiagramIcon_js"
	],
	"./TreeDiagramIcon.js": [
		"./src/components/ui/svgIcon/TreeDiagramIcon.js",
		9,
		"src_components_ui_svgIcon_TreeDiagramIcon_js"
	],
	"./TruckCheckCompleteIcon": [
		"./src/components/ui/svgIcon/TruckCheckCompleteIcon.js",
		9,
		"src_components_ui_svgIcon_TruckCheckCompleteIcon_js"
	],
	"./TruckCheckCompleteIcon.js": [
		"./src/components/ui/svgIcon/TruckCheckCompleteIcon.js",
		9,
		"src_components_ui_svgIcon_TruckCheckCompleteIcon_js"
	],
	"./TruckIcon": [
		"./src/components/ui/svgIcon/TruckIcon.js",
		9,
		"src_components_ui_svgIcon_TruckIcon_js"
	],
	"./TruckIcon.js": [
		"./src/components/ui/svgIcon/TruckIcon.js",
		9,
		"src_components_ui_svgIcon_TruckIcon_js"
	],
	"./TruckRightIcon": [
		"./src/components/ui/svgIcon/TruckRightIcon.js",
		9,
		"src_components_ui_svgIcon_TruckRightIcon_js"
	],
	"./TruckRightIcon.js": [
		"./src/components/ui/svgIcon/TruckRightIcon.js",
		9,
		"src_components_ui_svgIcon_TruckRightIcon_js"
	],
	"./TruckWaveIcon": [
		"./src/components/ui/svgIcon/TruckWaveIcon.js",
		9,
		"src_components_ui_svgIcon_TruckWaveIcon_js"
	],
	"./TruckWaveIcon.js": [
		"./src/components/ui/svgIcon/TruckWaveIcon.js",
		9,
		"src_components_ui_svgIcon_TruckWaveIcon_js"
	],
	"./TwitterIcon": [
		"./src/components/ui/svgIcon/TwitterIcon.js",
		9,
		"src_components_ui_svgIcon_TwitterIcon_js"
	],
	"./TwitterIcon.js": [
		"./src/components/ui/svgIcon/TwitterIcon.js",
		9,
		"src_components_ui_svgIcon_TwitterIcon_js"
	],
	"./TwoUserIcon": [
		"./src/components/ui/svgIcon/TwoUserIcon.js",
		9,
		"src_components_ui_svgIcon_TwoUserIcon_js"
	],
	"./TwoUserIcon.js": [
		"./src/components/ui/svgIcon/TwoUserIcon.js",
		9,
		"src_components_ui_svgIcon_TwoUserIcon_js"
	],
	"./Umbrella2Icon": [
		"./src/components/ui/svgIcon/Umbrella2Icon.js",
		9,
		"src_components_ui_svgIcon_Umbrella2Icon_js"
	],
	"./Umbrella2Icon.js": [
		"./src/components/ui/svgIcon/Umbrella2Icon.js",
		9,
		"src_components_ui_svgIcon_Umbrella2Icon_js"
	],
	"./UnSuccessIcon": [
		"./src/components/ui/svgIcon/UnSuccessIcon.js",
		9
	],
	"./UnSuccessIcon.js": [
		"./src/components/ui/svgIcon/UnSuccessIcon.js",
		9
	],
	"./User2": [
		"./src/components/ui/svgIcon/User2.js",
		9,
		"src_components_ui_svgIcon_User2_js"
	],
	"./User2.js": [
		"./src/components/ui/svgIcon/User2.js",
		9,
		"src_components_ui_svgIcon_User2_js"
	],
	"./User3": [
		"./src/components/ui/svgIcon/User3.js",
		9,
		"src_components_ui_svgIcon_User3_js"
	],
	"./User3.js": [
		"./src/components/ui/svgIcon/User3.js",
		9,
		"src_components_ui_svgIcon_User3_js"
	],
	"./User5Icon": [
		"./src/components/ui/svgIcon/User5Icon.js",
		9,
		"src_components_ui_svgIcon_User5Icon_js"
	],
	"./User5Icon.js": [
		"./src/components/ui/svgIcon/User5Icon.js",
		9,
		"src_components_ui_svgIcon_User5Icon_js"
	],
	"./UserBoardIcon": [
		"./src/components/ui/svgIcon/UserBoardIcon.js",
		9,
		"src_components_ui_svgIcon_UserBoardIcon_js"
	],
	"./UserBoardIcon.js": [
		"./src/components/ui/svgIcon/UserBoardIcon.js",
		9,
		"src_components_ui_svgIcon_UserBoardIcon_js"
	],
	"./UserCheckdIcon": [
		"./src/components/ui/svgIcon/UserCheckdIcon.js",
		9,
		"src_components_ui_svgIcon_UserCheckdIcon_js"
	],
	"./UserCheckdIcon.js": [
		"./src/components/ui/svgIcon/UserCheckdIcon.js",
		9,
		"src_components_ui_svgIcon_UserCheckdIcon_js"
	],
	"./UserContactIcon": [
		"./src/components/ui/svgIcon/UserContactIcon.js",
		9,
		"src_components_ui_svgIcon_UserContactIcon_js"
	],
	"./UserContactIcon.js": [
		"./src/components/ui/svgIcon/UserContactIcon.js",
		9,
		"src_components_ui_svgIcon_UserContactIcon_js"
	],
	"./UserIcon": [
		"./src/components/ui/svgIcon/UserIcon.js",
		9,
		"src_components_ui_svgIcon_UserIcon_js"
	],
	"./UserIcon.js": [
		"./src/components/ui/svgIcon/UserIcon.js",
		9,
		"src_components_ui_svgIcon_UserIcon_js"
	],
	"./UserInformation": [
		"./src/components/ui/svgIcon/UserInformation.js",
		9,
		"src_components_ui_svgIcon_UserInformation_js"
	],
	"./UserInformation.js": [
		"./src/components/ui/svgIcon/UserInformation.js",
		9,
		"src_components_ui_svgIcon_UserInformation_js"
	],
	"./UserLoadIcon": [
		"./src/components/ui/svgIcon/UserLoadIcon.js",
		9,
		"src_components_ui_svgIcon_UserLoadIcon_js"
	],
	"./UserLoadIcon.js": [
		"./src/components/ui/svgIcon/UserLoadIcon.js",
		9,
		"src_components_ui_svgIcon_UserLoadIcon_js"
	],
	"./UserOutlinedIcon": [
		"./src/components/ui/svgIcon/UserOutlinedIcon.js",
		9,
		"src_components_ui_svgIcon_UserOutlinedIcon_js"
	],
	"./UserOutlinedIcon.js": [
		"./src/components/ui/svgIcon/UserOutlinedIcon.js",
		9,
		"src_components_ui_svgIcon_UserOutlinedIcon_js"
	],
	"./UserProfileFillIcon": [
		"./src/components/ui/svgIcon/UserProfileFillIcon.js",
		9
	],
	"./UserProfileFillIcon.js": [
		"./src/components/ui/svgIcon/UserProfileFillIcon.js",
		9
	],
	"./UserlockIcon": [
		"./src/components/ui/svgIcon/UserlockIcon.js",
		9,
		"src_components_ui_svgIcon_UserlockIcon_js"
	],
	"./UserlockIcon.js": [
		"./src/components/ui/svgIcon/UserlockIcon.js",
		9,
		"src_components_ui_svgIcon_UserlockIcon_js"
	],
	"./UsersGroup": [
		"./src/components/ui/svgIcon/UsersGroup.js",
		9,
		"src_components_ui_svgIcon_UsersGroup_js"
	],
	"./UsersGroup.js": [
		"./src/components/ui/svgIcon/UsersGroup.js",
		9,
		"src_components_ui_svgIcon_UsersGroup_js"
	],
	"./UsersIcon": [
		"./src/components/ui/svgIcon/UsersIcon.js",
		9,
		"src_components_ui_svgIcon_UsersIcon_js"
	],
	"./UsersIcon.js": [
		"./src/components/ui/svgIcon/UsersIcon.js",
		9,
		"src_components_ui_svgIcon_UsersIcon_js"
	],
	"./VerifyUserIcon": [
		"./src/components/ui/svgIcon/VerifyUserIcon.js",
		9,
		"src_components_ui_svgIcon_VerifyUserIcon_js"
	],
	"./VerifyUserIcon.js": [
		"./src/components/ui/svgIcon/VerifyUserIcon.js",
		9,
		"src_components_ui_svgIcon_VerifyUserIcon_js"
	],
	"./WalkIcon": [
		"./src/components/ui/svgIcon/WalkIcon.js",
		9,
		"src_components_ui_svgIcon_WalkIcon_js"
	],
	"./WalkIcon.js": [
		"./src/components/ui/svgIcon/WalkIcon.js",
		9,
		"src_components_ui_svgIcon_WalkIcon_js"
	],
	"./WalletIcon": [
		"./src/components/ui/svgIcon/WalletIcon.js",
		9,
		"src_components_ui_svgIcon_WalletIcon_js"
	],
	"./WalletIcon.js": [
		"./src/components/ui/svgIcon/WalletIcon.js",
		9,
		"src_components_ui_svgIcon_WalletIcon_js"
	],
	"./WasteSewerIcon": [
		"./src/components/ui/svgIcon/WasteSewerIcon.js",
		9,
		"src_components_ui_svgIcon_WasteSewerIcon_js"
	],
	"./WasteSewerIcon.js": [
		"./src/components/ui/svgIcon/WasteSewerIcon.js",
		9,
		"src_components_ui_svgIcon_WasteSewerIcon_js"
	],
	"./WaterDropIcon": [
		"./src/components/ui/svgIcon/WaterDropIcon.js",
		9,
		"src_components_ui_svgIcon_WaterDropIcon_js"
	],
	"./WaterDropIcon.js": [
		"./src/components/ui/svgIcon/WaterDropIcon.js",
		9,
		"src_components_ui_svgIcon_WaterDropIcon_js"
	],
	"./WebcamCameraIcon": [
		"./src/components/ui/svgIcon/WebcamCameraIcon.js",
		9,
		"src_components_ui_svgIcon_WebcamCameraIcon_js"
	],
	"./WebcamCameraIcon.js": [
		"./src/components/ui/svgIcon/WebcamCameraIcon.js",
		9,
		"src_components_ui_svgIcon_WebcamCameraIcon_js"
	],
	"./WindDirectionArrowIcon": [
		"./src/components/ui/svgIcon/WindDirectionArrowIcon.js",
		9,
		"src_components_ui_svgIcon_WindDirectionArrowIcon_js"
	],
	"./WindDirectionArrowIcon.js": [
		"./src/components/ui/svgIcon/WindDirectionArrowIcon.js",
		9,
		"src_components_ui_svgIcon_WindDirectionArrowIcon_js"
	],
	"./WindDirectionIcon": [
		"./src/components/ui/svgIcon/WindDirectionIcon.js",
		9,
		"src_components_ui_svgIcon_WindDirectionIcon_js"
	],
	"./WindDirectionIcon.js": [
		"./src/components/ui/svgIcon/WindDirectionIcon.js",
		9,
		"src_components_ui_svgIcon_WindDirectionIcon_js"
	],
	"./WindIcon": [
		"./src/components/ui/svgIcon/WindIcon.js",
		9,
		"src_components_ui_svgIcon_WindIcon_js"
	],
	"./WindIcon.js": [
		"./src/components/ui/svgIcon/WindIcon.js",
		9,
		"src_components_ui_svgIcon_WindIcon_js"
	],
	"./colorfulAparatIcon.svg": [
		"./src/components/ui/svgIcon/colorfulAparatIcon.svg?3c25",
		1,
		"src_components_ui_svgIcon_colorfulAparatIcon_svg"
	],
	"./colorfulRubicaIcon.svg": [
		"./src/components/ui/svgIcon/colorfulRubicaIcon.svg?fa40",
		1,
		"src_components_ui_svgIcon_colorfulRubicaIcon_svg"
	],
	"./colorfulSoroshIcon.svg": [
		"./src/components/ui/svgIcon/colorfulSoroshIcon.svg?afd1",
		1,
		"src_components_ui_svgIcon_colorfulSoroshIcon_svg"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/components/ui/svgIcon lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;